
import React, { useCallback } from "react"
import Button from '../buttons/Button';

type Props = {
    title: string;
    index: number;
    activeTab: number;
    setSelectedTab: (index: number) => void;
}

const TabTitle: React.FC<Props> = ({ title, activeTab, setSelectedTab, index }) => {

    const onClick = useCallback(() => {
        setSelectedTab(index)
    }, [setSelectedTab, index])

    return (
        <li className="tabs-nav-list-item">
            <Button type="tab" action={onClick} text={title} activeTab={activeTab === index} />
        </li>
    )
}

export default TabTitle